import { Row, Typography } from 'antd';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { ProductiveHeading07, ProductiveHeading06 } from 'components/styles';

const { Text } = Typography;

export const StyledProjectArchiveDeleteControls = styled.div`
  padding-bottom: var(--spacing-05);
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: var(--spacing-07);
`;

export const MainSectionHeading = styled.p`
  ${ProductiveHeading06};
  margin-bottom: var(--spacing-03);
`;

export const CTASectionRow = styled(Row)`
  margin-bottom: var(--spacing-05);
`;

export const SectionTitle = styled(Text)`
  ${ProductiveHeading07};
`;
export const StyledButton = styled(Button)`
  border-color: var(--primary-color) !important;
  box-shadow: var(--shadow-highlight)
    rgba(var(--blue-60-in-rgb), var(--shadow-highlight-color-opacity)) !important;
`;
